export const staticInsuranceList= [
    {
      id: 1,
      accountingObjectId: 8,
      title: "آزاد"
    },
    {
      id: 2,
      accountingObjectId: 1,
      title: "نیروهای مسلح - عادی"
    },
    {
      id: 3,
      accountingObjectId: 2,
      title: "نیروهای مسلح ـ جانبازان"
    },
    {
      id: 4,
      accountingObjectId: 3515,
      title: "کمیته امداد"
    },
    {
      id: 5,
      accountingObjectId: 3,
      title: "صدا و سیما - بازنشسته"
    },
    {
      id: 6,
      accountingObjectId: 4,
      title: "صدا و سیما - کارمند"
    },
    {
      id: 7,
      accountingObjectId: 5,
      title: "تامین اجتماعی"
    },
    {
      id: 8,
      accountingObjectId: 3516,
      title: "شرکت نفت"
    },
    {
      id: 9,
      accountingObjectId: 3517,
      title: "بنیاد پانزده خرداد"
    },
    {
      id: 10,
      accountingObjectId: 3518,
      title: "شهرداری"
    },
    {
      id: 11,
      accountingObjectId: 6,
      title: "بیمه سلامت"
    },
    {
      id: 12,
      accountingObjectId: 3519,
      title: "بانک ملی"
    },
    {
      id: 13,
      accountingObjectId: 3520,
      title: "بانك تجارت"
    },
    {
      id: 14,
      accountingObjectId: 3521,
      title: "بانك توسعه و صادرات"
    },
    {
      id: 15,
      accountingObjectId: 3522,
      title: "بانك رفاه كارگران"
    },
    {
      id: 16,
      accountingObjectId: 3523,
      title: "بانك سپه"
    },
    {
      id: 17,
      accountingObjectId: 3524,
      title: "بانك صنعت و معدن"
    },
    {
      id: 18,
      accountingObjectId: 3525,
      title: "بانك كشاورزي"
    },
    {
      id: 19,
      accountingObjectId: 3526,
      title: "بانك مركزي"
    },
    {
      id: 20,
      accountingObjectId: 3527,
      title: "بانك مسكن"
    },
    {
      id: 21,
      accountingObjectId: 3528,
      title: "بانك ملت"
    },
    {
      id: 22,
      accountingObjectId: 3529,
      title: "توسعه كيش"
    },
    {
      id: 23,
      accountingObjectId: 3530,
      title: "رياست جمهوري"
    },
    {
      id: 24,
      accountingObjectId: 3531,
      title: "سازمان گسترش و نوسازي صنايع ايران"
    },
    {
      id: 25,
      accountingObjectId: 3532,
      title: "مركز پژوهش‌های مجلس"
    },
    {
      id: 26,
      accountingObjectId: 3533,
      title: "شركت شهر سالم تهران"
    },
    {
      id: 27,
      accountingObjectId: 3534,
      title: "شركت ملي صنايع مس ايران"
    },
    {
      id: 28,
      accountingObjectId: 3535,
      title: "شركت نفت فلات قاره ايران"
    },
    {
      id: 29,
      accountingObjectId: 3536,
      title: "كانون سردفتران و دفتر ياران"
    },
    {
      id: 30,
      accountingObjectId: 3537,
      title: "كتابخانه مجلس شوراي اسلامي"
    },
    {
      id: 31,
      accountingObjectId: 3538,
      title: "مجلس شوراي اسلامي"
    },
    {
      id: 32,
      accountingObjectId: 3539,
      title: "وزارت بهداشت"
    },
    {
      id: 33,
      accountingObjectId: 3540,
      title: "هواپيمايي آسمان"
    },
    {
      id: 34,
      accountingObjectId: 3541,
      title: "سایر"
    }
  ]